// extracted by mini-css-extract-plugin
var _1 = "jSmcPKiZ2iGz0L_80jHO";
var _2 = "jSmcPKiZ2iGz0L_80jHO";
export { _1 as "no-padding", _2 as "noPadding" }
